import React from 'react';

/*
 * The Messenger mark, from the design file.
 *
 * A brand logo keeps its own colours - it does not take currentColor and
 * does not follow the theme, because it is not ours to restyle. Only the
 * size is ours to set.
 *
 * Its ids are prefixed: six of these marks share a page, and an exported
 * SVG names its gradients paint0, paint1 and so on.
 */
const MessengerIcon = (props) => (
        <svg {...props}
        width={props.width ? props.width : 20}
        height={props.height ? props.height : 20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M10 17.612C14.4873 17.612 18.125 14.0891 18.125 9.74348C18.125 5.39784 14.4873 1.875 10 1.875C5.51269 1.875 1.875 5.39784 1.875 9.74348C1.875 12.107 2.95105 14.2271 4.65461 15.6695V17.2617C4.65461 17.8841 5.2885 18.3015 5.85368 18.0513L7.62062 17.2692C8.37315 17.4921 9.17212 17.612 10 17.612Z" fill="url(#messenger_paint0_linear_74_3017)"/>
        <path d="M8.05438 8.07082L5.69827 11.2931C5.44565 11.6386 5.89996 12.0536 6.24584 11.7933L8.25767 10.2793C8.46246 10.1252 8.74951 10.1231 8.95668 10.2742L10.746 11.5795C11.0891 11.8298 11.5795 11.7578 11.8293 11.4205L14.3003 8.0838C14.5566 7.73775 14.0988 7.31934 13.7524 7.58303L11.6254 9.20225C11.4206 9.35818 11.132 9.36104 10.9239 9.20922L9.14041 7.90819C8.79584 7.65682 8.30314 7.73061 8.05438 8.07082Z" fill="white"/>
        <defs>
        <linearGradient id="messenger_paint0_linear_74_3017" x1="10" y1="1.875" x2="7.39289" y2="18.0365" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B1FF"/>
        <stop offset="1" stopColor="#006BFF"/>
        </linearGradient>
        </defs>
        </svg>
);

export default MessengerIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/platforms/MessengerIcon.jsx